import React, { useState, useRef, useEffect } from 'react'
import styles from './CaddieInfo.module.scss'
import BackButton from '../../components/buttons/BackButton/BackButton'
import { useUser, useUpdateTourCaddieInfo } from '../../hooks'
import Select from 'react-select'
import CareerModal from './components/CareerModal'
import LanguageModal from './components/LanguageModal'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../store'

// Select 옵션들
const experienceOptions = [
	{ value: 'NEWBIE', label: '신입(1년 미만)' },
	{ value: 'ONE_TO_THREE', label: '1년 ~ 3년차' },
	{ value: 'FOUR_TO_SIX', label: '4년 ~ 6년차' },
	{ value: 'SEVEN_TO_TEN', label: '7년 ~ 10년차' },
	{ value: 'OVER_TEN', label: '10년 이상' },
]

const caddieTeamOptions = [
	{ value: 'spoeum', label: '스포이음' },
	{ value: 'voicecaddie', label: '보이스캐디' },
	{ value: 'mansujung', label: '만수정' },
	{ value: 'other', label: '기타' },
]

const CaddieInfo = () => {
	const { data: user } = useUser()
	const caddie = user?.tourCaddie
	const updateTourCaddieInfoMutation = useUpdateTourCaddieInfo()
	const { actions, state } = useStateMachine({ updateStore })

	// 스토어에서 데이터 가져오기
	const caddieData = state.caddieInfoInput || {}
	const careerData = caddieData.careers || []
	const languageData = caddieData.languages || []

	// 모달 상태
	const [isCareerModalOpen, setIsCareerModalOpen] = useState(false)
	const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false)

	useEffect(() => {
		if (caddie) {
			actions.updateStore({
				caddieInfoInput: {
					careerLevel: caddie.career_level || '',
					caddieTeam: caddie.caddie_team_name || '',
					selfIntroduction: caddie.self_introduction || '',
					careers: caddie.caddie_careers || [],
					languages: caddie.caddie_languages || [],
				},
			})
		}
	}, [caddie, actions])

	const handleSave = async () => {
		try {
			// 최신 상태에서 데이터 가져오기
			const latestCaddieData = state.caddieInfoInput || {}
			const latestCareerData = latestCaddieData.careers || []
			const latestLanguageData = latestCaddieData.languages || []

			// API에 전송할 데이터 구조 변환
			const updateData = {}

			// career_level 추가
			if (latestCaddieData.careerLevel) {
				updateData.career_level = latestCaddieData.careerLevel
			}

			// caddie_team_name 추가
			if (latestCaddieData.caddieTeam) {
				updateData.caddie_team_name = latestCaddieData.caddieTeam
			}

			// self_introduction 추가
			if (latestCaddieData.selfIntroduction) {
				updateData.self_introduction = latestCaddieData.selfIntroduction
			}

			// 경력 데이터 추가 (배열이 있으면 항상 포함)
			if (latestCareerData && latestCareerData.length > 0) {
				updateData.careers = latestCareerData.map((career) => ({
					tournament_date: career.tournament_date,
					tournament_rank: career.tournament_rank,
					tournament_name: career.tournament_name,
					league: career.league,
					is_representative: career.is_representative,
				}))
			}

			// 언어 데이터 추가 (배열이 있으면 항상 포함)
			if (latestLanguageData && latestLanguageData.length > 0) {
				updateData.languages = latestLanguageData.map((language) => ({
					language_name:
						language.language_name === 'OTHER'
							? language.custom_language
							: language.language_name,
					proficiency: language.proficiency,
				}))
			}

			console.log('캐디 정보 저장:', updateData)

			await updateTourCaddieInfoMutation.mutateAsync(updateData)
			alert('캐디 정보가 성공적으로 저장되었습니다.')
		} catch (error) {
			console.error('캐디 정보 저장 실패:', error)
			alert('캐디 정보 저장에 실패했습니다.')
		}
	}

	const handleCareerModalOpen = () => {
		setIsCareerModalOpen(true)
	}

	const handleCareerModalClose = () => {
		setIsCareerModalOpen(false)
	}

	const handleCareerFinish = (careers) => {
		actions.updateStore({
			caddieInfoInput: {
				...caddieData,
				careers: careers,
			},
		})
		setIsCareerModalOpen(false)
		console.log('경력 데이터:', careers)
	}

	const handleLanguageModalOpen = () => {
		setIsLanguageModalOpen(true)
	}

	const handleLanguageModalClose = () => {
		setIsLanguageModalOpen(false)
	}

	const handleLanguageFinish = (languages) => {
		actions.updateStore({
			caddieInfoInput: {
				...caddieData,
				languages: languages,
			},
		})
		setIsLanguageModalOpen(false)
		console.log('언어 데이터:', languages)
	}

	return (
		<div className={styles.caddieInfoWrapper}>
			<BackButton />
			<form
				style={{ marginTop: '40px' }}
				onSubmit={(e) => {
					e.preventDefault()
					handleSave()
				}}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						gap: '12px',
						alignItems: 'center',
					}}>
					<h2
						style={{
							fontSize: '24px',
							fontWeight: '600',
							color: '#1b1b1b',
							fontFamily: 'Pretendard-SemiBold',
						}}>
						캐디 정보
					</h2>

					<span
						style={{
							fontSize: '13px',
							fontWeight: '500',
							color: '#7d7d7d',
							fontFamily: 'Pretendard-Medium',
						}}>
						경력, 구단, 선호 투어 등
					</span>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '12px',
						marginTop: '40px',
					}}>
					{/* <p
						style={{
							fontSize: '13px',
							fontWeight: '500',
							color: '#7d7d7d',
							fontFamily: 'Pretendard-Medium',
						}}>
						프로가 제안할 때 보이는 내 프로필이에요
					</p> */}

					{/* TODO: 캐디 정보 입력 폼 구현 */}
					<div
						style={{
							padding: '12px 0',
						}}>
						{/* 경력 */}
						<div className={styles.infoBox}>
							<span className={styles.infoLabel}>경력</span>
							<Select
								value={
									experienceOptions?.find(
										(option) => option.value === caddieData?.careerLevel,
									) || null
								}
								onChange={(selectedOption) =>
									actions.updateStore({
										caddieInfoInput: {
											...caddieData,
											careerLevel: selectedOption?.value || '',
										},
									})
								}
								options={experienceOptions || []}
								placeholder="경력을 선택해주세요"
								isSearchable={false}
								classNamePrefix="custom-select"
							/>
						</div>

						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'space-between',
								padding: '8px 0',
								borderTop: '1px solid #e0e0e0',
							}}>
							<span className={styles.infoLabel}>
								주요 경력사항
								<span className={styles.choice}>(선택)</span>
							</span>
							<button
								type="button"
								className={styles.uploadButton}
								onClick={handleCareerModalOpen}>
								입력하기
							</button>
						</div>
						{careerData.length > 0 && (
							<div className={styles.dataDisplay}>
								{careerData.map((career, index) => (
									<div key={index} className={styles.dataItem}>
										<div className={styles.dataContent}>
											<div className={styles.dataHeader}>
												{career.is_representative && (
													<span className={styles.representativeBadge}>
														대표
													</span>
												)}
												<span className={styles.dataTitle}>
													{career.tournament_name}
												</span>
											</div>
											<div className={styles.dataDetails}>
												<span>
													{career.tournament_date
														? career.tournament_date.substring(0, 7)
														: ''}
												</span>
												<span>{career.league}</span>
											</div>
										</div>
										<div className={styles.dataRight}>
											<span className={styles.tournament_rank}>
												{career.tournament_rank === 'FIRST'
													? '우승'
													: career.tournament_rank === 'SECOND'
														? 'TOP2'
														: career.tournament_rank === 'THIRD'
															? 'TOP3'
															: career.tournament_rank === 'FOURTH'
																? 'TOP4'
																: career.tournament_rank === 'FIFTH'
																	? 'TOP5'
																	: career.tournament_rank ===
																		  'SIXTH'
																		? 'TOP6'
																		: career.tournament_rank ===
																			  'SEVENTH'
																			? 'TOP7'
																			: career.tournament_rank ===
																				  'EIGHTH'
																				? 'TOP8'
																				: career.tournament_rank ===
																					  'NINTH'
																					? 'TOP9'
																					: career.tournament_rank ===
																						  'TENTH'
																						? 'TOP10'
																						: career.tournament_rank}
											</span>
										</div>
									</div>
								))}
							</div>
						)}

						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'space-between',
								padding: '8px 0',
								borderTop: '1px solid #e0e0e0',
							}}>
							<span className={styles.infoLabel}>
								언어 능력
								<span className={styles.choice}>(선택)</span>
							</span>
							<button
								type="button"
								className={styles.uploadButton}
								onClick={handleLanguageModalOpen}>
								입력하기
							</button>
						</div>
						{languageData.length > 0 && (
							<div
								className={styles.dataDisplay}
								style={{ borderBottom: '1px solid #e0e0e0' }}>
								{languageData.map((language, index) => (
									<div key={index} className={styles.dataItem}>
										<div className={styles.dataHeader}>
											<span className={styles.dataTitle}>
												{language.language_name === 'OTHER'
													? language.custom_language
													: language.language_name}
											</span>
										</div>
										<div className={styles.dataDetails}>
											<span>
												{language.proficiency === 'BEGINNER'
													? '기초회화 가능'
													: language.proficiency === 'INTERMEDIATE'
														? '원활한 의사소통 가능'
														: language.proficiency === 'ADVANCED'
															? '네이티브'
															: language.proficiency}
											</span>
										</div>
									</div>
								))}
							</div>
						)}

						{/* 구단 */}
						<div className={styles.infoBox} style={{ marginTop: '32px' }}>
							<span className={styles.infoLabel}>구단</span>
							<Select
								value={
									caddieTeamOptions?.find(
										(option) => option.value === caddieData?.caddieTeam,
									) || null
								}
								onChange={(selectedOption) =>
									actions.updateStore({
										caddieInfoInput: {
											...caddieData,
											caddieTeam: selectedOption?.value || '',
										},
									})
								}
								options={caddieTeamOptions || []}
								placeholder="구단을 선택해주세요"
								isSearchable={false}
								classNamePrefix="custom-select"
							/>
						</div>

						<div className={styles.infoBox}>
							<span className={styles.infoLabel}>
								자기소개<span className={styles.choice}>(선택)</span>
							</span>
							<div className={styles.fillinBox}>
								<textarea
									className={styles.fillinTextarea}
									placeholder="경력, 주요 성과, 강점 등을 300자 내외로 입력해주세요. "
									value={caddieData?.selfIntroduction || ''}
									onChange={(e) =>
										actions.updateStore({
											caddieInfoInput: {
												...caddieData,
												selfIntroduction: e.target.value,
											},
										})
									}
								/>
							</div>
						</div>
					</div>
				</div>

				<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
					<button
						type="submit"
						disabled={updateTourCaddieInfoMutation.isPending}
						style={{
							backgroundColor: updateTourCaddieInfoMutation.isPending
								? '#e4e4e4'
								: 'black',
							color: updateTourCaddieInfoMutation.isPending ? '#999' : 'white',
							padding: '8px 12px',
							borderRadius: '4px',
							fontSize: '12px',
							fontWeight: '600',
							fontFamily: 'Pretendard-Medium',
							cursor: updateTourCaddieInfoMutation.isPending
								? 'not-allowed'
								: 'pointer',
							border: 'none',
						}}>
						{updateTourCaddieInfoMutation.isPending ? '저장 중...' : '저장'}
					</button>
				</div>
			</form>

			<CareerModal
				isModalOpen={isCareerModalOpen}
				onFinish={handleCareerFinish}
				onReturn={handleCareerModalClose}
				initialCareers={careerData}
			/>

			<LanguageModal
				isModalOpen={isLanguageModalOpen}
				onFinish={handleLanguageFinish}
				onReturn={handleLanguageModalClose}
				initialLanguages={languageData}
			/>
		</div>
	)
}

export default CaddieInfo
